<template>
  <component :is="$route.meta.layout || 'div'">
    <Toast />
    <nav-bar
      v-if="auth.isAuthenticated"
      :messages="messages"
    />
    <InactivityLogout />
    <router-view class="m-4" />
    <div class="text-xs ml-4 mb-4">
      <span class="uppercase">{{ appName }} {{ appVersion }} </span>
      <br />
      <span class="uppercase">CABANG {{ appCompany }}</span>
    </div>
    <Dialog
      :header="headerUpdate"
      v-model:visible="refreshDialog"
      :style="{ width: '50vw' }"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :modal="true"
      :closable="false"
    >
      <p class="m-0">
        Update aplikasi telah tersedia. Klik tombol Refresh untuk memperbaharui.
      </p>
      <template #footer>
        <Button
          label="Refresh"
          icon="pi pi-check"
          @click="updateApp"
          autofocus
        />
      </template>
    </Dialog>
    <ScrollTop />
  </component>
</template>

<script>
import CabangService from '@/services/CabangService'
import ProfileService from '@/services/ProfileService'
import SettingService from '@/services/SettingService'
import { useAuthStore } from '@/store/auth'
import ScrollTop from 'primevue/scrolltop'
import InactivityLogout from './components/InactivityLogout.vue'
import NavBar from './components/NavBar.vue'

export default {
  components: { NavBar, ScrollTop, InactivityLogout },
  inject: ['workbox', 'ability'],
  created() {
    this.settingService = new SettingService()
    this.cabangService = new CabangService()
    this.profileService = new ProfileService()
    this.auth = useAuthStore()
    if (this.workbox) {
      this.workbox.addEventListener('waiting', () => {
        this.refreshDialog = true
      })
    }

    const token = localStorage.getItem('aid')
    if (token) {
      this.auth.user = JSON.parse(localStorage.getItem('user'))
    } else {
      this.auth.logout()
    }
  },
  data() {
    return {
      cabang: null,
      cabangService: null,
      refreshDialog: false,
      messages: [],
      auth: {},
      appName: process.env.VUE_APP_APP_NAME,
      appVersion: process.env.VUE_APP_VERSION,
      dbVersion: '',
      appCompany: '',
    }
  },
  mounted() {
    this.loadSettings()
    window.addEventListener('authUpdated', this.loadSettings)
  },
  beforeUnmount() {
    window.removeEventListener('authUpdated', this.loadSettings)
  },
  computed: {
    headerUpdate() {
      return 'Update telah tersedia'
    },
  },
  methods: {
    async updateApp() {
      this.refreshDialog = false
      await this.workbox.messageSW({ type: 'SKIP_WAITING' })
    },
    async loadSettings() {
      if (this.auth.isAuthenticated) {
        const storedCompany = localStorage.getItem('appCompany')

        if (storedCompany) {
          this.appCompany = storedCompany
        } else {
          this.profileService.getCompanyProfile().then((res) => {
            this.appCompany = res.data.data.name
            localStorage.setItem('appCompany', this.appCompany)
          })
        }


        this.auth.refreshPermission(this.ability)
      }
    },
  },
}
</script>
